export default function CookiePolicy() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold mb-6">Cookie Policy</h1>
      <div className="space-y-4 text-slate-700">
        <p>
          Questa pagina descrive l'uso di cookie tecnici e cookie analytics utilizzati dalla piattaforma Norma HACCP.
        </p>
        <p>
          I cookie tecnici sono necessari al corretto funzionamento del servizio, inclusi autenticazione, sicurezza di sessione e preferenze essenziali.
        </p>
        <p>
          Gli eventuali cookie analytics sono utilizzati in forma compatibile con la normativa applicabile per migliorare performance, usabilita e contenuti del servizio.
        </p>
      </div>
    </div>
  );
}
